import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { SubscriptionModulesModel } from './Model/subscription-modules-model';
import { FuseNavigationService } from '../../@fuse/components/navigation/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseNavigationItem } from '../../@fuse/components/navigation';
import { defaultNavigation } from '../mock-api/common/navigation/data';
import { NavigationService } from '../core/navigation/navigation.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { environment } from '../../environments/environment';
import { MediaViewerComponent } from '../Common/media-viewer/media-viewer.component'
import { MatDialog } from '@angular/material/dialog';
declare var require: any
const FileSaver = require('file-saver');
import * as printJS from 'print-js';

@Injectable()
export class CommonService implements Resolve<any>
{
  private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;

  origin = location.origin;
  tracking_action_names = [
    { "Name": "Patroling", "Value": "0", "Image": origin + "/assets/icons/custom/tracking/Patroling.svg" },
    { "Name": "ShiftStart", "Value": "1", "Image": origin + "/assets/icons/custom/tracking/shift_start.svg" },
    { "Name": "ShiftEnd", "Value": "2", "Image": origin + "/assets/icons/custom/tracking/shift_end.svg" },
    { "Name": "Check-In", "Value": "3", "Image": origin + "/assets/icons/custom/tracking/check_in.svg" },
    { "Name": "Check-Out", "Value": "4", "Image": origin + "/assets/icons/custom/tracking/check_out.svg" },
    { "Name": "SiteTourStarted", "Value": "5", "Image": origin + "/assets/icons/custom/tracking/tour_start.svg" },
    { "Name": "SiteTourEnded", "Value": "6", "Image": origin + "/assets/icons/custom/tracking/tour_end.svg" },
    { "Name": "TaskStarted", "Value": "7", "Image": origin + "/assets/icons/custom/tracking/task_started.svg" },
    { "Name": "TaskEnded", "Value": "8", "Image": origin + "/assets/icons/custom/tracking/task_submitted.svg" },
    { "Name": "PassdownSubmitted", "Value": "9", "Image": origin + "/assets/icons/custom/tracking/passdown.svg" },
    { "Name": "ReportSubmitted", "Value": "10", "Image": origin + "/assets/icons/custom/tracking/report.svg" },
    { "Name": "WatchModeEntry", "Value": "11", "Image": origin + "/assets/icons/custom/tracking/watch_mode.svg" },
    { "Name": "DispatchCopied", "Value": "12", "Image": origin + "/assets/icons/custom/tracking/Dispatch_Copied.svg" },
    { "Name": "DispatchOntheWay", "Value": "13", "Image": origin + "/assets/icons/custom/tracking/Dispatch_On_The_Way.svg" },
    { "Name": "DispatchClosed", "Value": "14", "Image": origin + "/assets/icons/custom/tracking/Dispatch_Closed.svg" },
    { "Name": "TagScanned", "Value": "15", "Image": origin + "/assets/icons/custom/tracking/tag_scan.svg" },
    { "Name": "DispatchReopened", "Value": "16", "Image": origin + "/assets/icons/custom/tracking/Dispatch_Reopen.svg" },
    { "Name": "Idle", "Value": "17", "Image": origin + "/assets/icons/custom/tracking/idle.svg" },
    { "Name": "BreakStart", "Value": "18", "Image": origin + "/assets/icons/custom/tracking/break_start.svg" },
    { "Name": "BreakEnd", "Value": "19", "Image": origin + "/assets/icons/custom/tracking/break_end.svg" },
    { "Name": "CheckListCompleted", "Value": "20", "Image": origin + "/assets/icons/custom/tracking/checklist.svg" },
    { "Name": "GuardDeviceFall", "Value": "21", "Image": origin + "/assets/icons/custom/tracking/guard_fall.svg" },
    { "Name": "PostSiteTagScanned", "Value": "22", "Image": origin + "/assets/icons/custom/tracking/tag_scan_direct.svg" }, 
  ];
  notificationFilterList = [{ "name": "Checked-In", "value": 1 },
  { "name": "Checked-Out", "value": 2 },
  { "name": "Passdown Report", "value": 5 },
  { "name": "Task Report", "value": 6 },
  { "name": "Custom Report", "value": 7 },
  { "name": "Site Tour", "value": 8 },
  //{ "name": "Clocked-In", "value": 15 },
  //{ "name": "Clocked-Out", "value": 16 },
  { "name": "Watch Mode Report", "value": 19 }];
  admin_id: number = 0;
  /** Compatibility values consumed by the shared Job Order components. */
  user_id: number = 0;
  type: number = 1;
  role_permissions: any = {};
  client_id: number = 0;
  client_name: string = "";
  client_access_id: number = 0;
  admin_name: string = "";
  user_name: string = "";
  email_id: string = "";
  client_address: string = "";
  company_name: string = "";
  company_address: string = "";
  company_email: string = "";
  company_phone_no: string = "";
  company_logo: string = "";
  mobile_number: string = "";
  client_list: any = [];
  account_status = 0;
  modules: SubscriptionModulesModel;
  role: number = 1;
  audio_format = [".mp3", ".ogg", ".oga", ".mogg", ".raw", ".wav", ".webm", ".mpg", ".mpeg", ".m2v", ".3gp"];
  video_format = [".mp4", ".mov", ".wmv", ".flv", ".avi", ".mkv", ".ogv", ".ogg"];
  image_format = [".png", ".gif", ".jpg", ".jpeg"];
  time_format: string = "12";
  date_format: string = "MMM dd, yyyy";
  mobile_verified: boolean = false;
  profile_photo: any;
  //company_currency: any;
  skill_set_in_schedule: any;
  department_in_schedule: any;
  DateRangePickerStartDate = moment().subtract(6, "days").startOf('day');
  DateRangePickerEndDate = moment().endOf('day');
  DefaultStartDate = moment().subtract(3, 'years').startOf('year');
  DefaultEndDate = moment().endOf('day');
  DefaultOneYearStartDate = moment().subtract(1, 'years').startOf('day');
  week_starts_on: string = "Monday";
  locations_assigned: string = "";
  report_access: any = {};
  timeSelection24HoursList: any[] = ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00',
    '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30',
    '23:00', '23:30'
  ];
  timeSelection12HoursList: any[] = ['12:00 AM', '12:30 AM', '01:00 AM', '01:30 AM', '02:00 AM', '02:30 AM', '03:00 AM', '03:30 AM', '04:00 AM',
    '04:30 AM', '05:00 AM', '05:30 AM', '06:00 AM', '06:30 AM', '07:00 AM', '07:30 AM', '08:00 AM', '08:30 AM', '09:00 AM', '09:30 AM', '10:00 AM',
    '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM',
    '04:30 PM', '05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM', '07:00 PM', '07:30 PM', '08:00 PM', '08:30 PM', '09:00 PM', '09:30 PM', '10:00 PM', '10:30 PM',
    '11:00 PM', '11:30 PM'
  ];
  onUserProfileUpdated: BehaviorSubject<Boolean>;
  isExpanded = true;
  remove_time_zone_from_report: boolean = false;
  two_factor_auth_method: string = '';
  authenticator_app_configured: boolean = false;
  enable_two_step_authentication: boolean = false;
  hide_client_in_report: boolean = false;
  hide_postsite_in_report: boolean = false;
  hide_guard_in_report: boolean = false;
  show_total_time_as_decimal_hour: boolean = false;
  add_tour_check_point_into_dar_report: boolean = false;
  onFilterChanged: BehaviorSubject<any>;
  flter: any[];
  show_archived_data = false;
  report_type = "";
  display_date_format: string = "MMM dd, yyyy";
  selected_language = 'en-US';
  lang_list = [
    { 'name': 'English', 'id': 'en-US' },
    { 'name': 'Hindi', 'id': 'hi-IN' },
    { 'name': 'French', 'id': 'fr-FR' },
    { 'name': 'Spanish', 'id': 'es-ES' },

  ]
  main_plan_type = 1;
  onLangChanged: BehaviorSubject<any>;
  support_pin: string = '';
  map_type_list = [
    { name: "Roadmap", value: "roadmap" },
    { name: "Satellite", value: "satellite" },
    { name: "Hybrid", value: "hybrid" },
    { name: "Terrain", value: "terrain" }
  ];
  saved_column_list: any;
  onCustomColumnChanged = new BehaviorSubject<any[]>([]);

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(
    private _httpClient: HttpClient,
    private _fuseNavigationService: FuseNavigationService,
    private _navigationService: NavigationService,
    public _translateSerive: TranslateService,
    private paginatorIntl: MatPaginatorIntl,
    public dialog: MatDialog,


  ) {
    if (localStorage.getItem("IstableExpanded") != undefined && localStorage.getItem("IstableExpanded") != null) {
      if (localStorage.getItem("IstableExpanded") == "false") {
        this.isExpanded = false;
      }
    }
    this.onUserProfileUpdated = new BehaviorSubject(this.profile_photo);
    this.notificationFilterList?.sort((a, b) => a.name.localeCompare(b.name))
    this.onFilterChanged = new BehaviorSubject([]);
    this.onLangChanged = new BehaviorSubject('');
    this.onCustomColumnChanged = new BehaviorSubject<any[]>([]);

  }

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve, reject) => {

      Promise.all([

      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }


  /**
   * Get widgets
   *
   * @returns {Promise<any>}
   */



  getUserByToken<T>(): Observable<T> {
    return this._httpClient.post<T>('api/auth/getuserbytoken', {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).pipe(
      map((response: any) => {

        if (response != null) {
          this.admin_id = response.admin_id;
          this.user_id = response.user_id ?? 0;
          this.type = response.type ?? 1;
          this.role_permissions = response.role_permissions ?? {};
          this.client_access_id = response.client_access_id;
          this.client_id = response.client_id;
          this.client_name = response.client_name;
          this.admin_name = response.admin_name;
          this.email_id = response.email_id;
          this.user_name = response.contact_name;
          this.client_address = response.client_address;
          this.company_name = response.company_name;
          this.company_email = response.company_email;
          this.company_address = response.company_address;
          this.company_phone_no = response.company_phone;
          this.mobile_number = response.user_phone;
          //this.company_currency = (response.currency != "" && response.currency != null) ? response.currency : "$";
          this.time_format = (response.time_format != "" && response.time_format != null) ? response.time_format : "12";
          this.date_format = (response.date_format != "" && response.date_format != null) ? response.date_format : "MMM dd, yyyy";
          this.account_status = response.account_status;
          this.role = response.role;
          this.company_logo = response.company_logo;
          this.mobile_verified = response.mobile_verified;
          this.profile_photo = response.profile_photo;
          this.modules = new SubscriptionModulesModel();
          this.modules.dispatch_module = response.dispatch_module;
          this.modules.scheduling_module = response.scheduling_module;
          this.modules.invoicer_module = response.invoicer_module;
          this.modules.payroll_module = response.payroll_module;
          this.modules.tracking_module = response.tracking_module;
          this.modules.sms_module = response.sms_module;
          this.modules.visitor_module = response.visitor_module;
          this.modules.vehicle_patrol_module = response.vehicle_patrol_module;
          this.modules.parking_module = response.parking_module;
          this.client_list = response.client_list;
          this.skill_set_in_schedule = response.skill_set_in_schedule;
          this.department_in_schedule = response.department_in_schedule;
          this.locations_assigned = response.locations_assigned;
          this.remove_time_zone_from_report = response.remove_time_zone_from_report != null ? response.remove_time_zone_from_report : false;
          this.enable_two_step_authentication = response.enable_two_step_authentication != null ? response.enable_two_step_authentication : false;
          this.authenticator_app_configured = response.authenticator_app_configured != null ? response.authenticator_app_configured : false;
          this.two_factor_auth_method = response.two_factor_auth_method;
          this.add_tour_check_point_into_dar_report = response.add_tour_check_point_into_dar_report != null ? response.add_tour_check_point_into_dar_report : false;
          this.main_plan_type = response.main_plan_type;
          this.onUserProfileUpdated.next(true);
          this.support_pin = response.support_pin;
          //if (this.role == 0 && (this.locations_assigned == "" || this.locations_assigned == undefined)) {
          //  var postsite = {
          //    admin_id: this.admin_id,
          //    client_id: this.client_id,
          //    locations_assigned: this.locations_assigned
          //  }
          //  this.getPostSiteSelectList(postsite).subscribe((response: any) => {
          //    this.locations_assigned = response.map(item => item.post_site_id).toString();
          //  });
          //}
          this.report_access = response.report_access;
          //this.report_access.dispatch_log_details = true;
          this.saved_column_list = response?.column_list;

          if (response.language != undefined && response.language != null && response.language != '') {
            this.selected_language = response.language;
          }
          else {
            this.selected_language =  'en-US';

          }
          this._translateSerive.setFallbackLang(this.selected_language.split('-')[0]);
          this._translateSerive.use(this.selected_language.split('-')[0]);
          if (this.date_format == 'MMM dd, yyyy') {
            this.display_date_format = 'MMM DD, YYYY'
          }
          else if (this.date_format == 'MM/dd/yyyy') {
            this.display_date_format = 'MM/DD/YYYY'
          }
          else if (this.date_format == 'dd/MM/yyyy') {
            this.display_date_format = 'DD/MM/YYYY'
          }

          setTimeout(() => {
            this.refreshNavigation();
            this.paginatorIntl.itemsPerPageLabel = this.getTranslatedText('ItemsPerPage');
            this.paginatorIntl.nextPageLabel = this.getTranslatedText('NextPage');
            this.paginatorIntl.previousPageLabel = this.getTranslatedText('PreviousPage');
            this.paginatorIntl.changes.next();
          }, 2000);
        }
        return response;
      }),
    );
  }

  translateList<T>(list: T[], property: keyof T): void {
    const keys = list.map(item => item[property] as string);

    this._translateSerive.get(keys).subscribe(translations => {
      list.forEach(item => {
        const key = item[property] as string;
        item[property] = translations[key] as T[keyof T];
      });
    });
  }
  getClientSelectList<T>(client): Observable<T> {
    return this._httpClient.post<T>('api/common/getclientselectList', client, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  getPostSiteSelectList<T>(postsite): Observable<T> {
    return this._httpClient.post<T>('api/common/GetpostsiteselectList', postsite, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getGuardSelectList<T>(guard): Observable<T> {
    return this._httpClient.post<T>('api/common/Getguardselectlist', guard, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getUserSelectList<T>(user): Observable<T> {
    return this._httpClient.post<T>('api/common/getuserselectlist', user, {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    });
  }

  getIncidentSelectList<T>(incidentType): Observable<T> {
    return this._httpClient.post<T>('api/common/getincidentselectlist', incidentType, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getCustomReportSelectList<T>(admin_id: number): Observable<T> {
    return this._httpClient.post<any>('api/common/customreportselectlist?admin_id=' + admin_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })

  }

  getGuardLicenseTypeSelectList<T>(admin_id: number): Observable<T> {
    return this._httpClient.post<any>('api/common/getguardlicensetypeselectlist?admin_id=' + admin_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })

  }

  getSkillSetSelectList<T>(admin_id: number): Observable<T> {
    return this._httpClient.post<any>('api/common/getskillsetselectlist?admin_id=' + admin_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })

  }

  getDepartmentSelectList<T>(admin_id: number): Observable<T> {
    return this._httpClient.post<any>('api/common/getdepartmentselectlist?admin_id=' + admin_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })

  }

  EmailReport<T>(report, url): Observable<T> {
    return this._httpClient.post<T>(url, report, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getTopSearchResult<T>(data): Observable<T> {
    return this._httpClient.post<any>('api/common/gettopsearchresult', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getEventLogs<T>(log): Observable<T> {
    return this._httpClient.post<T>('api/common/geteventlogs', log, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  selectClient<T>(data): Observable<T> {
    return this._httpClient.post<T>('api/common/selectclient', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }


  toDataURL(imgUrl, callback) {
    var img = new Image();

    // onload fires when the image is fully loadded, and has width and height

    img.onload = function () {

      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png"),
        dataURL = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");

      callback(dataURL); // the base64 string

    };

    // set attributes and src 
    img.crossOrigin = "Anonymous";
    img.src = imgUrl;
  }

  refreshNavigation() {

    this._defaultNavigation.forEach((item) => {
      if (item.id == "dashboard") {
        item.isHidden = false;
      }
      else if (item.id == "post_order") {
        item.isHidden = this.report_access.post_order == true ? false : true;
      }
      //else if (item.id == "tracker") {
      //  item.isHidden = this.modules.tracking_module == true && this.report_access.tracking == true ? false : true
      //}
      else if (item.id == "visitor_manager") {
        item.isHidden = this.modules.visitor_module == true && this.report_access.visitor_log == true ? false : true
      }
      else if (item.id == "reports") {
        item.isHidden = (this.report_access.checkin == true || this.report_access.tours == true || this.report_access.task == true
        || this.report_access.dar == true || this.report_access.checklist == true || this.report_access.passdown_log == true || this.report_access.watchmode_log == true
        || this.report_access.tour_checkpoint == true || this.report_access.incident == true || this.report_access.standard == true) ? false : true
      }
      else if (item.id == "dispatcher") {
        item.isHidden = this.modules.dispatch_module == true && this.report_access.dispatch == true ? false : true
      }
      else if (item.id == "time_clock") {
        item.isHidden = (this.report_access.time_clock == true ||  this.report_access.view_time_card == true) ? false : true
        item.children.forEach((citem) => {
          if (citem.id == "time_log") {
            citem.isHidden = this.report_access.time_clock == true ? false : true;
          }
          else if (citem.id == "time_card") {
            citem.isHidden = this.report_access.view_time_card == true ? false : true;
          }
        })
      }
      else if (item.id == "scheduler") {
        item.isHidden = this.modules.scheduling_module == true ? false : true;
        if (this.modules.scheduling_module == true) {
          item.isHidden = (this.report_access.view_scheduler == true || this.report_access.view_shift_status == true) ? false : true;
          item.children.forEach((citem) => {
            if (citem.id == "schedule") {
              citem.isHidden = this.report_access.view_scheduler == true ? false : true;
            }
            else if (citem.id == "shift-status") {
              citem.isHidden = this.report_access.view_shift_status == true ? false : true;
            }
          })
        }
      }
      else if (item.id == "tracker") {
        item.isHidden = (this.main_plan_type != 3 && this.modules.tracking_module == true) ? false : true;
        if (this.modules.tracking_module == true && this.main_plan_type != 3) {
          item.isHidden = (this.report_access.view_tracking_history == true || this.report_access.view_live_tracking) ? false : true;
          item.children.forEach((citem) => {
            if (citem.id == "live_tracking") {
              citem.isHidden = this.report_access.view_live_tracking ? false : true;
            }
            else if (citem.id == "tracking_history") {
              citem.isHidden = this.report_access.view_tracking_history ? false : true;
            }
          })
        }
      }
      else if (item.id == "parking_manager") {

        item.isHidden = this.modules.parking_module == true ? false : true;
        if (this.modules.parking_module == true) {
          item.isHidden = (this.report_access.view_parking_manager_contacts == true ||
            this.report_access.view_parking_manager_vehicles == true ||
            this.report_access.view_parking_manager_areas == true ||
            this.report_access.view_parking_manager_lots == true ||
            this.report_access.view_parking_manager_incidents == true) ? false : true;
          item.children.forEach((citem) => {
            if (citem.id == "parking_contact") {
              citem.isHidden = this.report_access.view_parking_manager_contacts == true ? false : true;
            }
            else if (citem.id == "vehicles") {
              citem.isHidden = this.report_access.view_parking_manager_vehicles == true ? false : true;
            }
            else if (citem.id == "parking_area") {
              citem.isHidden = this.report_access.view_parking_manager_areas == true ? false : true;
            }
            else if (citem.id == "parking_lots") {
              citem.isHidden = this.report_access.view_parking_manager_lots == true ? false : true;
            }
            else if (citem.id == "parking_incidents") {
              citem.isHidden = this.report_access.view_parking_manager_incidents == true ? false : true;
            }
          })
        }
      }
      else if (item.id == "activity") {
        item.isHidden = false 
      }
    })

    this._navigationService.get().subscribe(result => {

    })
   
   
  }

  getTranslatedText(key) {
    return this._translateSerive.instant(key);
  }
  getContactDetailsForEmail<T>(data): Observable<T> {
    return this._httpClient.post<any>('api/common/getcontactdetailsforemail', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  checkEmail<T>(email: string): Observable<T> {
    if (email != '') {
      return this._httpClient.post<any>('api/common/checkemail?email=' + email, {
        reportProgress: true,
        observe: 'events',
        headers: { hideLoader: false }
      })
    }
  }

  plotMarker(latitude, longitude, title, icon_type, map): any {
    if (map != undefined) {
      let icon_url = origin + "/assets/icons/custom/tracking/green-marker.png";
      if (icon_type == 'green') {
        icon_url = origin + "/assets/icons/custom/tracking/green-marker.png";
      }
      else if (icon_type == 'red') {
        icon_url = origin + "/assets/icons/custom/tracking/red-marker.png";
      }
      else if (icon_type == "company") {
        icon_url = "/assets/icons/custom/tracking/company.svg";

      }
      else if (icon_type == "post_site") {
        icon_url = "/assets/icons/custom/tracking/post_site.svg";
      }
      else if (icon_type == 'check_in') {
        icon_url = origin + "/assets/icons/custom/tracking/check_in.svg";
      }
      else if (icon_type == 'check_out') {
        icon_url = origin + "/assets/icons/custom/tracking/check_out.svg";
      }
      else if (icon_type == 'tag_scan') {
        icon_url = origin + "/assets/icons/custom/tracking/tag_scan.svg";
      }
      else if (icon_type == 'geo_exit') {
        icon_url = origin + "/assets/icons/custom/tracking/geo_exit.svg";
      }
      else if (icon_type == 'geo_enter') {
        icon_url = origin + "/assets/icons/custom/tracking/geo_enter.svg";
      }
      else if (icon_type == 'panic') {
        icon_url = origin + "/assets/icons/custom/tracking/panic.svg";
      }
      else if (icon_type == 'tag_point') {
        icon_url = origin + "/assets/icons/custom/tracking/tag_point.svg";
      }
      else if (icon_type == 'Patroling') {
        icon_url = origin + "/assets/icons/custom/tracking/Patroling.svg";
      }
      else {
        let action = this.tracking_action_names.find(cat => cat.Value == icon_type);
        if (action != undefined) {
          icon_url = action.Image;
        }
      }
      let myLatLng = new google.maps.LatLng(latitude, longitude);
      let img = document.createElement("img");
      img.src = icon_url;
      img.style.width = '40px'
      img.style.height = '40px'

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: myLatLng,
        title: title,
        content: img
      });
      return marker;
    }
  }
   

  drawGeofence(shapes, drawingManager, geofence_data, map, geofenceVisibility): void {

    if (map != undefined) {
      shapes.length = 0;
      let tmp: any;
      for (let i = 0; i < geofence_data?.length; i++) {
        let geo_fence_list = geofence_data[i];
        if (geo_fence_list?.length > 0) {
          for (let j = 0; j < geo_fence_list?.length; j++) {
            const shape = geo_fence_list[j];
            if (shape != null && shape != undefined) {
              shape.restricted = shape.restricted === null ? "false" : shape.restricted;
              const fillColor = shape.restricted === "true" ? "#f7aab9" : "#daec9a";
              if (shape.type === "circle") {
                const latLng = new google.maps.LatLng(shape.geometry[0], shape.geometry[1]);
                tmp = new google.maps.Circle({
                  radius: Number(shape.radius), center: latLng,/* fillColor: '#ff5722'*/
                  fillOpacity: .5,
                  strokeWeight: 1,
                  strokeColor: shape.restricted === "true" ? "#530404" : "#04531a",
                  strokeOpacity: 1,
                  clickable: false,
                  editable: false,
                  fillColor: fillColor,
                  zIndex: 1
                });
              }
              tmp.setMap(map.googleMap);
              tmp.type = shape.type;
              tmp.restricted = shape.restricted;
              shapes.push(tmp);
            }
          }
        }
      }
      if (shapes != undefined && shapes.length > 0) {
        for (var i = 0; i < shapes.length; i++) {
          shapes[i].setVisible(geofenceVisibility);
        }
      }
    }
  }
  getIconUrlForMarker(icon_type): any {
    let icon_url = origin + "/assets/icons/custom/tracking/green-marker.png";
    if (icon_type == 'green') {
      icon_url = origin + "/assets/icons/custom/tracking/green-marker.png";
    }
    else if (icon_type == 'red') {
      icon_url = origin + "/assets/icons/custom/tracking/red-marker.png";
    }
    else if (icon_type == "company") {
      icon_url = "/assets/icons/custom/tracking/company.svg";

    }
    else if (icon_type == "post_site") {
      icon_url = "/assets/icons/custom/tracking/post_site.svg";
    }
    else if (icon_type == 'check_in') {
      icon_url = origin + "/assets/icons/custom/tracking/check_in.svg";
    }
    else if (icon_type == 'check_out') {
      icon_url = origin + "/assets/icons/custom/tracking/check_out.svg";
    }
    else if (icon_type == 'tag_scan') {
      icon_url = origin + "/assets/icons/custom/tracking/tag_scan.svg";
    }
    else if (icon_type == 'geo_exit') {
      icon_url = origin + "/assets/icons/custom/tracking/geo_exit.svg";
    }
    else if (icon_type == 'geo_enter') {
      icon_url = origin + "/assets/icons/custom/tracking/geo_enter.svg";
    }
    else if (icon_type == 'panic') {
      icon_url = origin + "/assets/icons/custom/tracking/panic.svg";
    }
    else if (icon_type == 'tag_point') {
      icon_url = origin + "/assets/icons/custom/tracking/tag_point.svg";
    }
    else if (icon_type == 'incident') {
      icon_url = origin + "/assets/icons/custom/tracking/incident.svg";
    }
    else if (icon_type == 'guard_fall') {
      icon_url = origin + "/assets/icons/custom/tracking/guard_fall.svg";
    }
    //else {
    //  let action = this.tracking_action_names.find(cat => cat.Value == icon_type);
    //  if (action != undefined) {
    //    icon_url = action.Image;
    //  }
    //}
    //let myLatLng = new google.maps.LatLng(latitude, longitude);
    //let img = document.createElement("img");
    //img.src = icon_url;
    //img.style.width = '40px'
    //img.style.height = '40px'

    //if (icon_type == 'incident') {
    //  img.className = "bounce";
    //}

    //const marker = new google.maps.marker.AdvancedMarkerElement({
    //  map,
    //  position: myLatLng,
    //  title: title,
    //  content: img
    //});
    return icon_url;

  }



  getParkingLotSelectList<T>(parkinglot): Observable<T> {
    return this._httpClient.post<T>('api/parkingmanager/getparkinglotselectlist', parkinglot, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  getParkingAreaSelectList<T>(parkinglot): Observable<T> {
    return this._httpClient.post<T>('api/parkingmanager/getParkingareafilterselectList', parkinglot, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  addupdatetempURLS<T>(data: any): Observable<T> {
    return this._httpClient.post<T>('api/common/addupdatetempURLS', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    });
  }
  updatePostsiteLatLong<T>(data): Observable<T> {

    const params = new HttpParams().set('Hide-Loader', "true");

    return this._httpClient.post<any>('api/common/updatePostsiteLatLong', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
      params
    })
  }
  getFilter(): Promise<any> {
    var data = {
      'admin_id': this.admin_id,
      client_id:this.client_id,
      'report_type': this.report_type,
      'time_format': this.time_format,
      'date_format': this.date_format,
    }
    return new Promise((resolve, reject) => {
      this._httpClient.post<any>('api/Report/getfilter', data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe((response: any) => {
        this.flter = response;
        this.onFilterChanged.next(this.flter);
        resolve(this.flter);
      }, reject);
    });
  }
  addUpdateFilter<T>(data): Observable<T> {
    return this._httpClient.post<any>('api/Report/addupdatefilter', data);
  }

  deleteFilter<T>(data): Observable<T> {
    return this._httpClient.post<any>('api/Report/deletefilter', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  detectType(ft: string): string {
    if (['.jpg', '.png', '.jpeg', '.webp','.gif'].includes(ft)) return 'image';
    if (['.mp4', '.mov'].includes(ft)) return 'video';
    if (['.mp3', '.wav'].includes(ft)) return 'audio';
    if (ft === '.pdf') return 'pdf';
    return 'other';
  }
  openViewer(files: any | any[], startIndex: number) {
    const inputFiles = Array.isArray(files) ? files : [files];
    if (inputFiles.length === 0) return;
    let type = this.detectType(
      inputFiles[startIndex].file_type ??
      inputFiles[startIndex]
        .slice(inputFiles[startIndex].lastIndexOf('.'))
        .toLowerCase()
    );
    if (type == 'image') {
      // clamp startIndex to a valid original index
      const originalStart = Math.max(0, Math.min(startIndex, inputFiles.length - 1));
      const allowedTypes = ['image', 'audio', 'video'];

      const mediaWithIdx = inputFiles.map((f, i) => {
        const fileType = f.file_type;
        const fileName = f.file_path || f.file || f || '';

        return {
          path: fileName,
          type: this.detectType(
            fileType ??
            fileName.slice(fileName.lastIndexOf('.')).toLowerCase()
          ),
          originalIndex: i
        };
      }).filter(m => allowedTypes.includes(m.type));



      // nothing valid left
      if (mediaWithIdx.length === 0) return;

      // try to find the item that corresponds to the original start index
      let safeIndex = mediaWithIdx.findIndex(m => m.originalIndex === originalStart);

      if (safeIndex === -1) {
        // prefer the nearest previous valid item
        for (let i = originalStart - 1; i >= 0; i--) {
          safeIndex = mediaWithIdx.findIndex(m => m.originalIndex === i);
          if (safeIndex !== -1) break;
        }
        // if none before, try forward
        if (safeIndex === -1) {
          for (let i = originalStart + 1; i < inputFiles.length; i++) {
            safeIndex = mediaWithIdx.findIndex(m => m.originalIndex === i);
            if (safeIndex !== -1) break;
          }
        }
        // fallback to first valid item
        if (safeIndex === -1) safeIndex = 0;
      }

      // remove originalIndex before passing to the dialog (optional)
      const mediaFiles = mediaWithIdx.map(({ originalIndex, ...rest }) => rest);

      if (mediaFiles[safeIndex].type === 'image') {
        this.dialog.open(MediaViewerComponent, {
          data: { files: mediaFiles, startIndex: safeIndex },
          panelClass: 'media-viewer-dialog',
          hasBackdrop: true,
          enterAnimationDuration: '0ms',
          exitAnimationDuration: '0ms'
        });
      }
    }
  }
  printBlobPDF(file: Blob) {
    const isMobile = window.innerWidth < 1024;
    const fileUrl = window.URL.createObjectURL(file);
    if (isMobile) {

      // Show browser-specific print instructions
      if (this.isIOS()) {
        alert("To print: Tap the Share icon → Print.");
      }
      else if (this.isAndroidChrome()) {
        alert("To print: Tap the menu (⋮) → Share → Print.");
      }
      else if (this.isAndroidFirefox()) {
        alert("To print: Tap the menu → Page → Print.");
      }
      else {
        alert("To print this PDF, open your browser menu and select Print.");
      }

      // Safari Fix: open a blank tab immediately (allowed by Safari)
      const newTab: any = window.open('', '_blank');

      if (!newTab) {
        // Fallback if popup blocked
        window.location.href = fileUrl;
        return;
      }

      // Update tab after microtask (Safari-safe)
      setTimeout(() => {
        newTab.location.href = fileUrl;
      }, 0);




    } else {
      // Desktop — use printJS
      printJS({ printable: fileUrl, type: 'pdf', showModal: true });
    }
  }
  printPDF(data) {
    const isMobile = window.innerWidth < 1024;
    if (isMobile) {

      // Show browser-specific print instructions
      if (this.isIOS()) {
        alert("To print: Tap the Share icon → Print.");
      }
      else if (this.isAndroidChrome()) {
        alert("To print: Tap the menu (⋮) → Share → Print.");
      }
      else if (this.isAndroidFirefox()) {
        alert("To print: Tap the menu → Page → Print.");
      }
      else {
        alert("To print this PDF, open your browser menu and select Print.");
      }

      // Safari Fix: open a blank tab immediately (allowed by Safari)
      const newTab: any = window.open('', '_blank');

      if (!newTab) {
        // Fallback if popup blocked
        window.location.href = data.file_path;
        return;
      }

      // Update tab after microtask (Safari-safe)
      setTimeout(() => {
        newTab.location.href = data.file_path;
      }, 0);




    } else {
      // Desktop — use printJS
      printJS({ printable: data.file_path, type: 'pdf', showModal: true });
    }
  }

  isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  }

  isAndroidChrome() {
    return /android/i.test(navigator.userAgent) &&
      /chrome/i.test(navigator.userAgent) &&
      !/phoenix|opera|firefox/i.test(navigator.userAgent);
  }

  isAndroidFirefox() {
    return /android/i.test(navigator.userAgent) &&
      /firefox/i.test(navigator.userAgent);
  }
  downloadFile(fileUrl: string, filename: string) {
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      // Safari Fix: open a blank tab immediately (allowed by Safari)
      const newTab: any = window.open('', '_blank');

      if (!newTab) {
        // Fallback if popup blocked
        window.location.href = fileUrl;
        return;
      }

      // Update tab after microtask (Safari-safe)
      setTimeout(() => {
        newTab.location.href = fileUrl;
      }, 0);

    } else {
      // Desktop: force download
      FileSaver.saveAs(fileUrl, filename);
    }
  }

  downloadFileWithBlob(file: Blob, filename: string) {

    const exists = ['invoice', 'estimate'].some(x => filename.toLowerCase().includes(x));
    if (!exists) {
      const parts = filename.split('.');
      const name = parts[0];
      const extension = parts[1];
      const date = moment().format('DD-MM-YYYY');
      filename = name + "-" + date + "." + extension;
    }
    const isMobile = window.innerWidth < 1024;
    const fileUrl = window.URL.createObjectURL(file);

    if (isMobile) {
      // Safari Fix: open a blank tab immediately
      const newTab: any = window.open('', '_blank');

      if (!newTab) {
        // Fallback if popup is blocked
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(fileUrl);
        return;
      }

      // Update tab after microtask
      setTimeout(() => {
        newTab.location.href = fileUrl;

        // Don't revoke immediately because the new tab needs the URL
        setTimeout(() => {
          window.URL.revokeObjectURL(fileUrl);
        }, 1000);
      }, 0);

    } else {
      // Desktop: force download
      //direct download
      FileSaver.saveAs(file, filename);
      window.URL.revokeObjectURL(fileUrl);



    }
  }
  getGeocodeLatLongFromAddress(address: string, type?: string): Promise<any> {
    return new Promise((resolve, reject) => {

      if (type === 'company') {
        const cachedLocation = localStorage.getItem(address);
        if (cachedLocation) {
          try {
            const parsed = JSON.parse(cachedLocation);
            if (parsed.lat && parsed.lng) {
              console.warn(parsed);
              return resolve(parsed);
            }
          } catch (e) {
            console.warn('Invalid cached location format:', e);
          }
        }
      }

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: address }, (results, status) => {
        if (status === 'OK' && results.length > 0) {
          const latitude = results[0].geometry.location.lat();
          const longitude = results[0].geometry.location.lng();
          const location = { lat: latitude, lng: longitude };
          if (type === 'company') {
            localStorage.setItem(address, JSON.stringify(location));
          }
          resolve(location);
        } else {
          reject(`Geocode failed: ${status}`);
        }
      });
    });
  }
  formatDateTime(date: any): string {
    if (!date) return '';

    let format = this.date_format;

    format = format.replace('yyyy', 'YYYY');
    format = format.replace('dd', 'DD');

    const timeFormat =
      this.time_format == "12"
        ? "hh:mm A"
        : "HH:mm";

    return moment(date).format(`${format} ${timeFormat}`);
  }

  getFormatedDateTime(datetime): string {
    var date_format = this.date_format;
    var time_format = this.time_format;

    var format = "MM/DD/YYYY";

    if (date_format == 'MMM dd, yyyy') {
      format = "MMM DD, yyyy";
    }
    else if (date_format == 'MM/dd/yyyy') {
      format = "MM/DD/yyyy";
    }
    else if (date_format == 'dd/MM/yyyy') {
      format = "DD/MM/yyyy";
    }

    if (time_format == "12") {
      format = format + " hh:mm A";
    }
    else {
      format = format + " HH:mm";
    }

    return moment(datetime).format(format);
  }
  getFormatedDate(date): string {

    let format = 'MM/DD/YYYY';

    if (this.date_format == 'MMM dd, yyyy') {
      format = 'MMM DD, YYYY';
    }
    else if (this.date_format == 'MM/dd/yyyy') {
      format = 'MM/DD/YYYY';
    }
    else if (this.date_format == 'dd/MM/yyyy') {
      format = 'DD/MM/YYYY';
    }

    return moment(date).format(format);
  }

  getMatDateFormats() {

    let format = this.date_format;

    format = format
      .replace(/yyyy/g, 'YYYY')
      .replace(/dd/g, 'DD');

    return {
      parse: {
        dateInput: format
      },
      display: {
        dateInput: format,
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMM YYYY'
      }
    };
  }
  generateSupportPin<T>(): Observable<T> {
  return this._httpClient.post<T>(
    'api/auth/generatesupportpin',
    {
      client_access_id: this.client_access_id
    }
  );
  }

  getPostsitePostOrderSelectList<T>(): Observable<T> {
    return this._httpClient.post<any>('/api/common/getjobsitejoborderselectlist?admin_id=' + this.admin_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  getTaskSelectList<T>(location_id): Observable<T> {
    return this._httpClient.post<any>('/api/common/gettaskselectlist?admin_id=' + this.admin_id + '&location_id=' + location_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  getChecklistSelectList<T>(location_id): Observable<T> {
    return this._httpClient.post<any>('/api/common/getchecklistselectlist?admin_id=' + this.admin_id + '&location_id=' + location_id, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  getFieldWorkers<T>(data): Observable<T> {

    return this._httpClient.post<any>('api/jobsite/getassignedworker', data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });


  }
  getGuardSelectListOnDocSign<T>(guard): Observable<T> {
    return this._httpClient.post<T>('api/common/Getguardselectlistondocsign', guard, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
  addUpdateCustomColumn<T>(data: any): Observable<T> {
    return this._httpClient.post<T>('api/common/addupdatecustomcolumn', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    });
  }
  getColumnForTable(form_name: string, default_list: any[], fixedColumns: string[]) {

    const displayedColumns = [...fixedColumns];

    const item = this.saved_column_list?.find(
      x => x.form_name === form_name
    );

    const columns = item
      ? JSON.parse(item.custom_column)
      : default_list;

    const selectedColumns = columns
      .filter((x: any) => x.is_select)
      .map((x: any) => x.value);

    const checkboxIndex = displayedColumns.indexOf('checkbox');

    if (checkboxIndex !== -1) {
      displayedColumns.splice(checkboxIndex + 1, 0, ...selectedColumns);
    } else {
      displayedColumns.unshift(...selectedColumns);
    }

    return displayedColumns;
  }
  UpdateDisplayColumn(columns: any[]) {
    this.onCustomColumnChanged.next(columns);
  }

}
